export enum MessagesTabLabel {
  All = 'All',
  Alarms = 'Alarms',
  Warnings = 'Warnings',
  OfflineWarnings = 'OfflineWarnings',
  Infos = 'Infos',
}
